"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var DotFilled = function DotFilled(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "50 0 350 350"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M 200, 240  m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0",
    fill: "currentColor"
  })));
};
var _default = exports.default = DotFilled;